import axios from 'axios';

const api = axios.create({
  baseURL: "https://ibscbs.tributacaohotline.com.br/",
});

const interceptor = async (config) => {
  // const token = await StorageService.getToken();
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`;
  // }
  return config;
};

api.interceptors.request.use(interceptor);

const responseInterceptor = (response) => response;
const errorInterceptor = async (error) => {
  if (error.response?.data?.detail === 'Token expired') {

  }
  return Promise.reject(error);
};

api.interceptors.response.use(responseInterceptor, errorInterceptor);
export { api };
